export const refreshScripts = (container) => {
	let scripts = container.querySelectorAll('script')
	scripts.forEach((script) => eval(script.innerHTML))
}

export default () => { }